import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop — global route-change scroll reset.
 *
 * Ensures every navigation to a new URL path lands at the top of the
 * destination page (i.e. its hero section). Covers all vectors:
 *   - Nav-menu Link clicks (About, Careers, Products, Solutions, etc.)
 *   - Direct URL entry
 *   - Browser back/forward buttons
 *   - Any programmatic `navigate()` call anywhere in the app
 *
 * Same-page smooth-scrolls (e.g. "Learn more" scroll-into-view) do NOT
 * change `location.pathname`, so this effect does not interfere.
 *
 * Rendered once, inside <Router>, above the route tree.
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
